module.exports = __webpack_public_path__ + "img/bg.e7b53a7b.png";